import React from 'react';
import PT from 'prop-types';

import { InputError, Label, SubLabel } from 'common/form';

import { CheckboxContainer, StyledInput, Labels } from './styled';

const InputCheckbox = ({
  input, meta, children, ...otherProps
}) => (
  <CheckboxContainer center={otherProps.center}>
    <StyledInput
      {...input}
      {...otherProps}
      type="checkbox"
      submitFailed={meta.submitFailed}
      error={meta.error}
      id={otherProps.id || input.name}
    />
    <Labels>
      {otherProps.label && <Label htmlFor={otherProps.id || input.name}>{otherProps.label}</Label>}
      {otherProps.subLabel && <SubLabel>{otherProps.subLabel}</SubLabel>}
      {children}
    </Labels>
    <InputError meta={meta} />
  </CheckboxContainer>
);

InputCheckbox.defaultProps = {
  meta: {
    error: undefined,
    submitFailed: false,
  },
};

InputCheckbox.propTypes = {
  input: PT.object,
  meta: PT.object,
  children: PT.node,
};

export default InputCheckbox;
